import { sortBy, map, fromPairs, reduce, isNull, isUndefined, isArray } from 'lodash'
import $ from 'jquery'

const $window = $(window)

export const sortByKeys = object => {
  const keys = Object.keys(object)
  const sortedKeys = sortBy(keys)
  return fromPairs(
    map(sortedKeys, key => [key, object[key]])
  )
}

export const isMobile = (breakpoint) => $window.width() < (breakpoint || 992)

export const toQueryString = (obj) => {
  return reduce(obj, function (result, value, key) {
    if (!isNull(value) && !isUndefined(value)) {
      if (isArray(value)) {
        result += reduce(value, function (result1, value1) {
          if (!isNull(value1) && !isUndefined(value1)) {
            result1 += key + '=' + value1 + '&';
            return result1
          } else {
            return result1;
          }
        }, '')
      } else {
        result += key + '=' + value + '&';
      }
      return result;
    } else {
      return result
    }
  }, '').slice(0, -1);
}

export const strip_tags = (content) => {
  let $filter = $('<span></span>')
  $filter.html(content)
  return $filter.text()
}


/**
 * @param color Expressed as either rgb(...), rgba(...), or a #hex
 * @see https://awik.io/determine-color-bright-dark-using-javascript/
 */
export const lightOrDark = (color) => {
  // Variables for red, green, blue values
  var r, g, b, hsp

  // Check the format of the color, HEX or RGB?
  if (color.match(/^rgb/)) {
    // If RGB --> store the red, green, blue values in separate variables
    color = color.match(/^rgba?\((\d+),\s*(\d+),\s*(\d+)(?:,\s*(\d+(?:\.\d+)?))?\)$/)

    r = color[1]
    g = color[2]
    b = color[3]
  } else {
    // If hex --> Convert it to RGB: http://gist.github.com/983661
    color = +("0x" + color.slice(1).replace(color.length < 5 && /./g, '$&$&'))

    r = color >> 16
    g = color >> 8 & 255
    b = color & 255
  }

  // HSP (Highly Sensitive Poo) equation from http://alienryderflex.com/hsp.html
  hsp = Math.sqrt(
    0.299 * (r * r) +
    0.587 * (g * g) +
    0.114 * (b * b)
  )

  // console.log(r, g, b, hsp)

  // Using the HSP value, determine whether the color is light or dark
  if (hsp > 130) {
    return 'light'
  } else {
    return 'dark'
  }
}

export const textOnLightOrDark = (color) => {
  return lightOrDark(color) === 'light' ? 'dark' : 'light'
}